import { render } from "./BaseModalBuy.vue?vue&type=template&id=6f6c603e&scoped=true"
import script from "./BaseModalBuy.vue?vue&type=script&lang=js"
export * from "./BaseModalBuy.vue?vue&type=script&lang=js"

import "./BaseModalBuy.vue?vue&type=style&index=0&id=6f6c603e&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6c603e"]])

export default __exports__